import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule, HttpClient } from '@angular/common/http';
import { NgPipesModule } from 'ngx-pipes';
import { NgxPaginationModule } from 'ngx-pagination'; // <-- import the module
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MdComponentsModule } from './shared/md-material';

import { NavBarComponent } from './shared/nav-bar/nav-bar.component';
import { BreadCrumbComponent } from './shared/bread-crumb/bread-crumb.component';
import { HomeComponent } from './views/home/home.component';
import { Covid19Component } from './views/covid19/covid19.component';
import { CovidSelfAssessmentComponent } from './views/covid-self-assessment/covid-self-assessment.component';

import { environment } from '../environments/environment';
import { Step2Component } from './views/step2/step2.component';
import { Step3Component } from './views/step3/step3.component';
import { Step4Component } from './views/step4/step4.component';
import { Step5Component } from './views/step5/step5.component';
import { Step7Component } from './views/step7/step7.component';
import { Step1Component } from './views/step1/step1.component';
import { Step6Component } from './views/step6/step6.component';
import { BuildChatbotComponent } from './views/build-chatbot/build-chatbot.component';
import { AngularFireModule } from '@angular/fire';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { SelfIsolationAssessmentComponent } from './views/self-isolation-assessment/self-isolation-assessment.component';
import { ContactTracingComponent } from './views/contact-tracing/contact-tracing.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    NavBarComponent,
    BreadCrumbComponent,
    HomeComponent,
    Covid19Component,
    CovidSelfAssessmentComponent,
    Step2Component,
    Step3Component,
    Step4Component,
    Step5Component,
    Step7Component,
    Step1Component,
    Step6Component,
    BuildChatbotComponent,
    SelfIsolationAssessmentComponent,
    ContactTracingComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    NgPipesModule, // ngx-pipes
    NgxPaginationModule, // ngx-pagination
    BrowserAnimationsModule, // required animations module
    MdComponentsModule, // angular-material module
    TranslateModule.forRoot({ // @ngx-translate/core
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFireDatabaseModule,
    ToastrModule.forRoot({
      timeOut: 8000,
      positionClass: 'toast-bottom-center',
      preventDuplicates: true,
    }) // ToastrModule added
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
